module.exports = __webpack_public_path__ + "static/img/xueshengewm.249ebb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xueshengewm.png
// module id = VuUo
// module chunks = 10